var config = require('../config.js')
module.exports = {
  getTicketGropList: config.host + '/tktins/api/v1/myTicket/list/c', // 获取票夹列表
  getAllTicket: config.host + '/tktins/api/v1/myTicket/allList/c', // 获取票夹列表
  getAllListStatus: config.host + '/tktins/api/v1/myTicket/allListStatus/c', // 获取是否票夹
  getTicketGropList2: config.host + '/tktins/api/v1/order/orderList/c', // 获取票夹order列表
  getTicketGropDetail: config.host + '/tktins/api/v1/order/orderDetail/c', // 获取票夹order详情
}